<template>
  <checkbox-multi-select
    label="student.label_filter_fullname_username"
    :options="familyData"
    v-model="selected"
    trackBy="_id"
    displayField="full_name"
    :itemTemplate="itemTemplate"
    @filtering="$emit('filtering', $event.text)"
  >
  </checkbox-multi-select>
</template>
<script>
import Vue from "vue";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";

const itemVue = Vue.component("itemTemplate", {
  template: `<span><span>{{data.full_name}}</span> - <span>{{data.username}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

export default {
  name: "family-select-component",
  components: { CheckboxMultiSelect },
  props: ["familyData"],
  data() {
    return {
      itemTemplate: function(e) {
        return {
          template: itemVue
        };
      },
      selected: []
    };
  },
  watch: {
    selected: function() {
      this.$emit("update-selected", this.selected);
    }
  }
};
</script>
